import './ox-chart.js'

import cloneDeep from 'lodash-es/cloneDeep.js'

import { ComponentNature, error, HTMLOverlayElement, Properties, sceneComponent } from '@hatiolab/things-scene'

import { OxChart } from './ox-chart.js'

const NATURE: ComponentNature = {
  mutable: false,
  resizable: true,
  rotatable: true,
  properties: [
    {
      type: 'chartjs',
      label: '',
      name: 'chart'
    }
  ],
  'value-property': 'data',
  help: 'scene/component/chartjs'
}

@sceneComponent('chartjs')
export default class ChartJS extends HTMLOverlayElement {
  private _isChartChanged = false
  private _isDataChanged = false

  get nature() {
    return NATURE
  }

  get hasTextProperty() {
    return false
  }

  get tagName() {
    return 'ox-chart'
  }

  dispose(): void {
    ;(this.element as OxChart)?.dispose()

    super.dispose()
  }

  isShadowable() {
    return false
  }

  createElement() {
    super.createElement()

    const { width, height } = this.bounds
    const element = this.element as OxChart
    const data = this.data

    element.width = width
    element.height = height

    this._setChartConfig(element)
    element.data = data
  }

  /* component.property => element.property */
  setElementProperties(element: OxChart) {
    this.setState('lineWidth', 0) // border 표현이 자연스럽게 바뀌면 지울것.

    const { chart: chartConfig } = this.state
    const { width, height } = this.bounds
    const data = this.data

    try {
      element.width = width
      element.height = height

      if (chartConfig && this._isChartChanged) {
        this._setChartConfig(element)
        this._isChartChanged = false
      }

      if (this._isDataChanged) {
        element.data = data
        this._isDataChanged = false
      }
    } catch (e) {
      error(e)
    }
  }

  _setChartConfig(element: OxChart) {
    const { chart: chartConfig, fontSize = 12, fontFamily, fontColor, shadow } = this.state
    // shadow 신규 키 (offsetX/offsetY/blur) 우선, 옛 키 (left/top/blurSize) 는 fallback —
    // drawer (things-scene/effect/shadow.ts) 의 readShadow 와 동일 규칙.
    const s = (shadow || {}) as {
      offsetX?: number
      offsetY?: number
      blur?: number
      left?: number
      top?: number
      blurSize?: number
      color?: string
    }
    const offsetX = s.offsetX ?? s.left ?? 0
    const offsetY = s.offsetY ?? s.top ?? 0
    const blur = s.blur ?? s.blurSize ?? 0
    const color = s.color ?? 'transparent'

    const fontOption = {
      defaultFontSize: fontSize,
      defaultFontFamily: fontFamily,
      defaultFontColor: fontColor
    }

    const shadowOption = {
      shadowOffsetX: offsetX,
      shadowOffsetY: offsetY,
      shadowBlur: blur,
      shadowColor: color
    }

    const cloneChartConf = cloneDeep(chartConfig)

    cloneChartConf.options = {
      ...cloneChartConf.options,
      ...fontOption
    }

    cloneChartConf.data.datasets = cloneChartConf.data.datasets.map((dataset: any) => {
      return {
        ...dataset,
        ...shadowOption
      }
    })

    element.options = cloneChartConf
  }

  onchange(after: Properties, before: Properties) {
    this._isChartChanged = false

    if ('chart' in after || 'fontSize' in after || 'fontFamily' in after || 'fontColor' in after || 'shadow' in after)
      this._isChartChanged = true

    super.onchange(after, before)
  }

  onchangeData(data: any) {
    this._isDataChanged = true
  }
}
